<template>
<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label class="control-label">Logradouro</label>
      <input
        class="form-control"
        type="text"
        name="street"
        v-validate="modelValidations.additionalData.street"
        v-model.trim="customer.address.street"
        autofocus
        autocomplete="off"
      />
      <small
        class="text-danger"
        v-show="street.invalid"
      > {{ getError('street') }}
      </small>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label class="control-label">Número</label>
      <input
        class="form-control"
        type="text"
        name="number"
        v-validate="modelValidations.additionalData.number"
        v-model.trim="customer.address.number"
        v-mask="'000000000'"
        autocomplete="off"
      />
      <small
        class="text-danger"
        v-show="number.invalid"
      > {{ getError('number') }}
      </small>
    </div>
  </div>

  <div class="col-md-6">
    <div class="form-group">
      <label class="control-label">CEP</label>
      <input
        class="form-control"
        type="text"
        name="zip"
        v-validate="modelValidations.additionalData.zip"
        v-model.trim="customer.address.zip"
        v-mask="'00000-000'"
        autocomplete="off"
      />
      <small
        class="text-danger"
        v-show="zip.invalid"
      > {{ getError('zip') }}
      </small>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label class="control-label">Bairro</label>
      <input
        class="form-control"
        type="text"
        name="neighborhood"
        v-validate="modelValidations.additionalData.neighborhood"
        v-model.trim="customer.address.neighborhood"
        autocomplete="off"
      />
      <small
        class="text-danger"
        v-show="neighborhood.invalid"
      > {{ getError('neighborhood') }}
      </small>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label class="control-label">Município</label>
      <select
        name="city"
        v-validate="modelValidations.additionalData.city"
        v-model.trim="customer.address.city"
        class="form-control"
      >
        <option
          value=""
          disabled
        >Selecione ...
        </option>
        <option
          v-for="option in citiesOptions"
          :key="option.value"
          :value="option.value"
        >{{ option.label }}
        </option>
      </select>
      <small
        class="text-danger"
        v-show="city.invalid"
      > {{ getError('city') }}
      </small>
    </div>
  </div>
  <div class="col-md-12">
    <div class="form-group">
      <label class="control-label">Complemento</label>
      <input
        class="form-control"
        type="text"
        name="complement"
        v-validate="modelValidations.additionalData.complement"
        v-model.trim="customer.address.complement"
        autocomplete="off"
      />
      <small
        class="text-danger"
        v-show="complement.invalid"
      > {{ getError('complement') }}
      </small>
    </div>
  </div>
</div>
</template>

<script>
import { mapFields } from 'vee-validate'
import { mapGetters } from 'vuex'

export default {
  name: 'address-form',

  computed: {
    ...mapFields(['street', 'number', 'neighborhood', 'city', 'zip', 'complement']),
    ...mapGetters('customers', {
      customer: 'customer',
      modelValidations: 'validations'
    }),
    ...mapGetters('project', {
      citiesOptions: 'citiesOptions'
    })
  },

  methods: {
    getError (fieldName) {
      return this.errors.first(fieldName)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Customer/AddressForm.vue